import React from "react";
import ChangePassword from "../fragments/change-password";



export default class passwordUpdate extends React.Component {

    render() {

        return (
            <div>
                <div id="headerBar"></div>
                <div style={
                    {
                        "display": "flex",
                        "justifyContent": "center",
                        "paddingTop": "180px"
                    }
                }>
                    <ChangePassword pageProps={this.props}></ChangePassword>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/jsx/components/pages/password-update-page.jsx